<template>
    <div class="loading-container">
        <p>{{ statusMessage }}</p>
        <AlertModal v-if="showModal" :message="modalMessage" @close="handleModalClose" />
        <div v-if="isLoading" class="spinner-loading"></div>
    </div>
</template>
<script>
import AlertModal from '../../components/AlertModal.vue';

export default {
    name: "AuthToken",
    components: { AlertModal },
    data() {
        return {
            isLoading: true,
            statusMessage: 'Validando acesso...',
            showModal: false,
            modalMessage: '',
        }
    },
    methods: {
        handleModalClose() {
            this.showModal = false;
            this.modalMessage = '';
            window.close();
        },
        handleLtiToken() {
            const Url = window.location;
            const ltikToken = new URLSearchParams(Url.search).get('ltik');

            if (!ltikToken) {
                this.statusMessage = 'Token LTI não encontrado';
                this.modalMessage = 'Token LTI inválido. Acesse novamente pelo LMS.';
                this.showModal = true;
                this.isLoading = false;
                return;
            }

            this.isLoading = true;

            this.$store.dispatch('loginLti', {
                ltikToken: ltikToken
            })
                .then(() => {
                    this.statusMessage = 'Acesso validado! Redirecionando...';

                    setTimeout(() => {
                        window.history.replaceState({}, '', window.location.pathname);
                        this.$router.push('/home');
                    }, 1000);
                })
                .catch(error => {
                    console.error('Erro na validação LTI:', error);

                    this.statusMessage = 'Erro na validação';

                    if (error.message && error.message.includes('não autorizado')) {
                        this.modalMessage = 'Perfil não autorizado para acesso via LTI.';
                    } else {
                        this.modalMessage = 'Erro ao validar o acesso, tente fazer o login novamente a partir da ferramenta. Ou contate o administrador da sua instituição.';
                    }

                    this.showModal = true;
                    this.isLoading = false;
                });
        },
        handleUrlParams() {
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.has('ltik')) {
                this.$store.commit('LOGOUT');
            }

            if (!this.$store.state.auth.isAuthenticated) {
                this.handleLtiToken();
            } else {
                this.$router.push('/home');
            }
        },
    },
    mounted() {
        this.handleUrlParams();
    }

}
</script>
<style scoped src="../../styles/AuthToken.css" />